import Const from '../const';
import createReducer from '../config/create_reducer';

const clearedErrors = ({ errorType, state }) => {
  const clearedErrorKeys = Object.keys(state.applicationErrors).filter((err) => err !== errorType);
  const clearedError = {};
  clearedErrorKeys.forEach((key) => { clearedError[key] = state.applicationErrors[key]; });
  return clearedError;
};

const getDefaultState = () => ({
  applicationErrors: {}
});

const handler = {
  [Const.application.error]: (state, { error }) => ({
    ...state,
    applicationErrors: { ...state.applicationErrors, ...error }
  }),
  [Const.application.clearError]: (state, { errorType }) => ({
    ...state,
    applicationErrors: clearedErrors({ errorType, state })
  })
};

export default createReducer(getDefaultState(), handler);
